interface InternalFeatureFlagsConfigProvider {
    rules: ReadonlyMap<FeatureFlagRuleId, FeatureFlagRule>;
    features: ReadonlyMap<FeatureFlagName, Feature>;
}

export interface FeatureFlagRule {
    readonly id: FeatureFlagRuleId;
    validate(ctx: unknown): boolean;
}

export type FeatureFlagRuleId = string;

export interface Feature {
    readonly name: FeatureFlagName;
    readonly rules?: FeatureFlagRuleId[];
    readonly enabled?: boolean;
}

export type FeatureFlagName = string;

export class FeatureFlagsRulesServiceBase {
    private readonly rules = new Map<FeatureFlagRuleId, FeatureFlagRule>();
    private readonly features = new Map<FeatureFlagName, Feature>();

    public registerRule(...rules: FeatureFlagRule[]): this {
        rules.map(r => this.rules.set(r.id, r));
        return this;
    }

    public registerFlag(...flags: Feature[]): this {
        flags.map(f => this.features.set(f.name, f));
        return this;
    }

    public get conifg(): InternalFeatureFlagsConfigProvider {
        return {
            rules: this.rules,
            features: this.features
        };
    }

    public getFlagStatus<TCtx = unknown>(name: FeatureFlagName, ctx?: TCtx): boolean {
        const { rules, features } = this.conifg;
        const feature = features.get(name);
        if (!feature) return false;
        
        const { rules: featureRules, enabled } = feature;
        return (featureRules || []).length > 0
            ? (featureRules || [])
                .map(ruleName => rules.get(ruleName))
                .every(rule => !!(rule && rule.validate(ctx)))
            : !!enabled;
    }
}
